import { Button, Dialog, Grid } from '@material-ui/core'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import React, { useEffect, useState } from 'react'
import { useResErrors, useRoutes } from 'hooks'
import moment from 'moment'
import useTaskApis from 'hooks/useTaskApis'
import { MISSED, PAYMENT } from 'constants/deals'
import { isExpiredEvent, parseJson } from 'lib/utils'
import {
  CS_CALL_CLIENT,
  CS_ISSUANCE_CAR,
  CS_ISSUE,
  CS_ISSUE_MANAGER,
  CS_MEET_CLIENT,
  MISSING
} from 'constants/events'
import { SalesService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import AccordionTwoHead from 'asterX-UI/Accordion/AccordionTwoHead'
import { Modal } from 'asterX-UI/Modals'
import CloseTaskComponent from 'components/Mobile/Tasks/CloseTaskComponent'
import CreateTaskComponent from 'components/Mobile/Tasks/CreateTaskComponent'
import CloseRLModal from 'components/Mobile/CloseRLModal'
import { useTaskModalStyles } from './work-list-tasks.styles'
import { GRAY_COLORS } from '../../../asterX-UI'
import { FieldInfoNG } from '../../../asterX-UI/DataDisplay'
import AsterTypography from '../../../asterX-UI/Typography/AsterTypography'
import AsterButton from '../../../asterX-UI/Buttons/AsterButton'
import ChevronLeftIcon from '../../../asterX-UI/Icons/ChevronLeftIcon'
import { WorkListSelectionHistory } from '../WorkListSelectionHistory/WorkListSelectionHistory'
import { WorkListClientNeeds } from '../WorkListClientNeeds/WorkListClientNeeds'
import { useWorkListViewRopStore } from '../../../context/WorkListViewStore/Rop/WorkListViewStore.rop'
import CommentItem from 'components/Desktop/CommentItem'
import { DEAL_VIEW_PATH, HOME_PATH } from 'routes/constants.routes'

export const WorkListTaskModal = ({
  task,
  isOpen,
  onClose,
  isList = false
}) => {
  const {
    actions: { handleUpdateStatus }
  } = useWorkListViewRopStore()
  const router = useRoutes()
  const classes = useTaskModalStyles()
  const endDateSplit = task.end.split(' ')

  const getTime = () => {
    const date = moment(endDateSplit, 'YYYY-MM-DD')
    const isThisYear = date.isSame(new Date(), 'year')
    const isToday = date.isSame(new Date(), 'day')
    const isTomorrow = date.isSame(moment(new Date()).add(1, 'day'), 'day')
    const isExpired = isExpiredEvent(task)

    if (isToday) {
      return {
        label: 'Сегодня ' + endDateSplit[1],
        className: 'today'
      }
    }

    if (isTomorrow) {
      return {
        label: 'Завтра ' + endDateSplit[1],
        className: 'tomorrow'
      }
    }

    if (isThisYear) {
      return {
        label: date.format('Do MMM ') + endDateSplit[1],
        className: isExpired ? 'expired' : ''
      }
    }

    return {
      label: date.format('Do MMM YYYY ') + endDateSplit[1],
      className: isExpired ? 'expired' : ''
    }
  }

  const endDate = getTime()

  const { completeEvent, taskIsLoading } = useTaskApis()
  const { standardCheck } = useResErrors()

  const [open, setOpen] = useState({
    isCloseTaskOpen: false,
    isCloseRlModalOpen: false,
    isCreateTask: false
  })
  const [commentsRSE, setCommentsRSE] = useState(null)
  const [sale, setSale] = useState(null)
  const [loading, setLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [comments, setComments] = useState([])

  const onCall = () => {
    const callElement = document.createElement('a')
    callElement.setAttribute(
      'href',
      `tel:+${task.contactPhone1.toStandardPhone()}`
    )

    callElement.click()
  }

  const handleOpen = type => () => {
    setOpen(prevState => ({
      ...prevState,
      [type]: !prevState?.[type]
    }))
  }

  const onSaveCloseTask = async isNew => {
    if (isNew) {
      handleOpen('isCloseTaskOpen')()
      return handleOpen('isCreateTask')()
    }
    onClose()
    handleOpen('isCloseTaskOpen')()
  }

  const onSaveNewTask = () => {
    onClose()
  }

  const onReasonClose = async result => {
    return await completeEvent({
      data: {
        type: MISSING,
        id: task.id,
        result
      },
      onSuccess: async res => {
        setLoading(true)
        await handleUpdateStatus(MISSED)
        onClose()
        setLoading(false)
      }
    })
  }

  const getSaleById = () => {
    setLoading(true)

    SalesService.getByIdForSelection(task.dealId)
      .then(res =>
        standardCheck(
          res,
          () => {
            setCommentsRSE(parseJson(res.data?.commentsRSE))
            setSale(res.data)
          },
          {
            onFail: () => {
              onClose()
            }
          }
        )
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const getAllComments = async () => {
    await SalesService.getAllComments(sale?.globalId).then(res => {
      if (res.status === 200) {
        setComments(res?.data)
      }
    })
  }

  useEffect(() => {
    getSaleById()
  }, [])

  useEffect(() => {
    getAllComments()
  }, [sale?.globalId])

  return (
    <>
      <Dialog
        fullScreen
        open={isOpen}
        style={{
          backgroundColor: '#FAFAFA'
        }}
      >
        <PageContainerDesktop>
          <LoaderBackdrop loading={taskIsLoading} />
          <Grid item xs={12} style={{ marginBottom: 24 }}>
            <AsterButton size="small" onClick={onClose}>
              <ChevronLeftIcon />
              {task?.title}
            </AsterButton>
          </Grid>
          <Grid item container spacing={6} style={{ margin: '24px 0' }}>
            <Grid item>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="№ РЛ"
                isVertical
              >
                <AsterTypography>
                  {task?.globalId || task?.dealId || '-'}
                </AsterTypography>
              </FieldInfoNG>
            </Grid>
            <Grid item>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="Срок выполнения"
                isVertical
              >
                <AsterTypography>{endDate.label}</AsterTypography>
              </FieldInfoNG>
            </Grid>
            <Grid item>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="Клиент"
                isVertical
              >
                <AsterTypography>
                  {task?.contactFullname || '-'}
                </AsterTypography>
              </FieldInfoNG>{' '}
            </Grid>
            <Grid item>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="Менеджер"
                isVertical
              >
                <AsterTypography>
                  {task?.assignToFullname || '-'}
                </AsterTypography>
              </FieldInfoNG>{' '}
            </Grid>
            <Grid item>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="Филиал"
                isVertical
              >
                <AsterTypography>{task?.subdivision || '-'}</AsterTypography>
              </FieldInfoNG>
            </Grid>
            <Grid item xs={12}>
              <FieldInfoNG
                labelStyle={{ minWidth: 81 }}
                label="Описание"
                isVertical
              >
                <AsterTypography>{task?.description || '-'}</AsterTypography>
              </FieldInfoNG>
            </Grid>
          </Grid>

          <Grid item container spacing={3}>
            {commentsRSE && (
              <Grid item xs={12}>
                <AccordionTwoHead
                  heading={'Потребности клиента'}
                  style={{
                    border: `1px solid ${GRAY_COLORS[200]}`,
                    borderRadius: 10
                  }}
                  accordionStyles={{ boxShadow: 'none' }}
                >
                  <div className={classes.needs}>
                    <WorkListClientNeeds isDisabled commentsRSE={commentsRSE} />
                  </div>
                </AccordionTwoHead>
              </Grid>
            )}
            <Grid item xs={12}>
              <AccordionTwoHead
                style={{
                  border: `1px solid ${GRAY_COLORS[200]}`,
                  borderRadius: 10
                }}
                heading={'История подбора'}
                accordionStyles={{ boxShadow: 'none' }}
              >
                <WorkListSelectionHistory
                  saleId={task.dealId}
                  tradeInCarVin={sale?.tradeInCarVin}
                />{' '}
              </AccordionTwoHead>
            </Grid>
            <Grid item xs={12}>
              <AccordionTwoHead
                style={{
                  border: `1px solid ${GRAY_COLORS[200]}`,
                  borderRadius: 10
                }}
                heading={'Коментарии'}
                accordionStyles={{ boxShadow: 'none' }}
              >
                <Grid item xs={12} md={12}>
                  {comments?.map(
                    (comment, index) =>
                      !!comment.text && (
                        <CommentItem
                          comment={comment}
                          key={`comment_${index}`}
                          isLast={comments?.length === index}
                        />
                      )
                  )}
                </Grid>
              </AccordionTwoHead>
            </Grid>
          </Grid>
          {!task?.completedDate && (
            <Grid
              item
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={3}
              style={{ marginTop: 24 }}
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleOpen('isCreateTask')()
                    setIsEdit(true)
                  }}
                >
                  {'Редактировать задачу'}
                </Button>
              </Grid>
              {[
                CS_CALL_CLIENT,
                CS_MEET_CLIENT,
                CS_ISSUANCE_CAR,
                CS_ISSUE,
                CS_ISSUE_MANAGER
              ].includes(task.type) && (
                <>
                  <Grid item>
                    <Button
                      variant="contained"
                      onClick={handleOpen('isCloseTaskOpen')}
                    >
                      Закрыть задачу
                    </Button>
                  </Grid>
                  {task.type !== CS_ISSUE && task.type !== CS_ISSUE_MANAGER && (
                    <Grid item>
                      <Button
                        className={classes.errorBtn}
                        variant="containedSecondary"
                        fullWidth
                        onClick={handleOpen('isCloseRlModalOpen')}
                      >
                        В упущен
                      </Button>
                    </Grid>
                  )}
                </>
              )}
              {isList && (
                <Grid item>
                  <Button
                    fullWidth
                    onClick={() =>
                      router.goTo(`${HOME_PATH}${DEAL_VIEW_PATH}/${sale.id}`)
                    }
                  >
                    Перейти в рл
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
        </PageContainerDesktop>
      </Dialog>
      <Modal open={open.isCloseTaskOpen} fullWidth>
        <CloseTaskComponent
          onClose={handleOpen('isCloseTaskOpen')}
          taskType={task.type}
          onSave={onSaveCloseTask}
          taskId={task?.id}
        />
      </Modal>
      <Modal open={open.isCreateTask} fullWidth>
        <CreateTaskComponent
          saleId={task?.dealId}
          globalId={task?.globalId}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          client={{
            contactFullname: task.contactFullname,
            phoneNumber: task.contactPhone1 || '',
            additionalPhoneNumber: task.contactPhone2 || ''
          }}
          onClose={handleOpen('isCreateTask')}
          onSuccess={onSaveNewTask}
          editData={{
            taskType: task.type,
            description: task.description,
            date: task.end
          }}
          otherData={{
            id: task?.id
          }}
          isEdit={isEdit}
        />
      </Modal>
      <Modal open={open.isCloseRlModalOpen} fullWidth>
        <CloseRLModal
          onClose={handleOpen('isCloseRlModalOpen')}
          onSave={onReasonClose}
          workList={task}
        />
      </Modal>
    </>
  )
}
